import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=faf779b4&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=faf779b4&prod&scoped=true&lang=css"
import style1 from "./Formulario.vue?vue&type=style&index=1&id=faf779b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf779b4",
  null
  
)

export default component.exports